import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { dayId: Number }
  static targets = ["popover"]

  declare dayIdValue: number
  declare readonly popoverTarget: HTMLElement

  connect() {
    this.position()

    requestAnimationFrame(() => {
      this.popoverTarget.classList.add("visible")
    })
  }

  // Positionne la bulle au-dessus de la cellule correspondante
  position() {
    if (this.popoverTarget.classList.contains("auth-modal")) return

    const cell = document.getElementById(`cell-${this.dayIdValue}`)
    if (!cell) return

    const popover = this.popoverTarget
    const cellRect = cell.getBoundingClientRect()

    // Important : le popover doit être rendu pour avoir des dimensions
    const popoverRect = popover.getBoundingClientRect()

    const margin = 10
    const arrowHeight = 10

    // Centrage horizontal
    let left = cellRect.left + window.scrollX + (cellRect.width / 2) - (popoverRect.width / 2)
    // Positionnement vertical (au-dessus par défaut)
    let top = cellRect.top + window.scrollY - popoverRect.height - arrowHeight

    // Gestion des bords (Viewport collisions)
    if (left < margin) left = margin
    if (left + popoverRect.width > window.innerWidth - margin) {
      left = window.innerWidth - popoverRect.width - margin
    }

    // Si ça dépasse en haut, on met en dessous
    if (top < window.scrollY + margin) {
      top = cellRect.bottom + window.scrollY + arrowHeight
      popover.classList.add("bottom") // Inverse la flèche CSS
    }

    popover.style.top = `${top}px`
    popover.style.left = `${left}px`

    // Ajustement dynamique de la flèche pour qu'elle pointe toujours vers la cellule
    const cellCenter = cellRect.left + window.scrollX + (cellRect.width / 2)
    const arrowLeft = cellCenter - left
    // On limite la flèche pour qu'elle ne sorte pas des coins arrondis
    const safeArrowLeft = Math.max(12, Math.min(popoverRect.width - 12, arrowLeft))

    popover.style.setProperty('--arrow-left', `${safeArrowLeft}px`)
  }

  // Fermeture via touche Echap
  closeWithKeyboard(event: KeyboardEvent) {
    if (event.key === "Escape") {
      this.close(event)
    }
  }

  close(event?: Event) {
    if (event) event.preventDefault()

    this.popoverTarget.classList.remove("visible")

    setTimeout(() => {
      // On vide le conteneur parent (le Turbo Frame cible)
      // this.element est le <div> wrapper avec data-controller="note"
      this.element.remove()
    }, 200)
  }
}
